import { Accordion } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { TaxRulesAccordionBody } from './components';

import './TaxRules.scss';

interface TaxRulesProps {
  variantId: string;
}

function TaxRules({ variantId }: Readonly<TaxRulesProps>) {
  const t = useTranslationCatalog('products.detail.invoiceSettings');

  return (
    <div className="stratus--container-tax-rules">
      <Accordion>
        <Accordion.Item index="0">
          <Accordion.Header
            subtitle={t('infoTaxRules')}
            title={t('titleTaxRules')}
            borderBottom="base"
          />
          <TaxRulesAccordionBody variantId={variantId} />
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default TaxRules;
